export const ClickIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={className}
    >
      <path
        d="M17.9648 14.8667L16.6064 15.3251C16.2314 15.4501 15.9314 15.7417 15.8064 16.1251L15.3481 17.4834C14.9564 18.6584 13.3064 18.6334 12.9398 17.4584L11.3981 12.5001C11.0981 11.5167 12.0064 10.6001 12.9814 10.9084L17.9481 12.4501C19.1148 12.8167 19.1314 14.4751 17.9648 14.8667Z"
        fill="white"
      />
      <path
        d="M18.0002 9.58325C18.0002 9.94159 17.9752 10.2999 17.9335 10.6499C17.9002 10.8999 17.6418 11.0499 17.4002 10.9749L13.3585 9.71659C12.4585 9.44159 11.5002 9.67492 10.8335 10.3333C10.1668 10.9999 9.92517 11.9749 10.2085 12.8749L11.4585 16.8999C11.5335 17.1416 11.3752 17.3999 11.1252 17.4333C10.7752 17.4749 10.4335 17.4999 10.0835 17.4999C5.6335 17.4999 2.05017 13.8416 2.16683 9.35825C2.2835 5.22492 5.72517 1.78326 9.8585 1.66659C14.3418 1.54992 18.0002 5.13325 18.0002 9.58325Z"
        fill="white"
      />
    </svg>
  )
}
